export enum PERMISSION_SCOPE {
  ACCOUNTS = 'ACCOUNTS',
  FINANCE = 'FINANCE',
  INTEGRATIONS = 'INTEGRATIONS',
  LOANS = 'LOANS',
  ORDERS = 'ORDERS',
  POS_CUSTOMIZATION = 'POS_CUSTOMIZATION',
  SETTINGS = 'SETTINGS',
  STAFF = 'STAFF',
  MENUS = 'MENUS',
}

/* Routes that needs permission, routes not defined here will have free access (for instance /loading) */
export const PERMISSION_PATHS: Record<string, PERMISSION_SCOPE[]> = {
  /* ACCOUNTS gives permission to: */
  '/admins': [PERMISSION_SCOPE.ACCOUNTS],
  '/admins/create': [PERMISSION_SCOPE.ACCOUNTS],

  /* FINANCE gives permission to: */
  '/dashboard': [PERMISSION_SCOPE.FINANCE],

  '/quicksight/namespaces': [PERMISSION_SCOPE.FINANCE],
  '/quicksight/namespaces/:formcode': [PERMISSION_SCOPE.FINANCE],
  '/quicksight/access-rights': [PERMISSION_SCOPE.FINANCE],
  '/quicksight/access-rights/:formcode': [PERMISSION_SCOPE.FINANCE],

  '/adyen/account-holders': [PERMISSION_SCOPE.FINANCE],
  '/adyen/balance-onboarding': [PERMISSION_SCOPE.FINANCE],
  '/adyen/payments': [PERMISSION_SCOPE.FINANCE],
  '/adyen/terminals': [PERMISSION_SCOPE.FINANCE],
  '/adyen/split-configs': [PERMISSION_SCOPE.FINANCE],
  '/adyen/split-configs/:name': [PERMISSION_SCOPE.FINANCE],
  '/payouts-beta': [PERMISSION_SCOPE.FINANCE],
  '/payouts-beta/:id': [PERMISSION_SCOPE.FINANCE],

  '/reports': [PERMISSION_SCOPE.FINANCE],
  '/app-pos-report': [PERMISSION_SCOPE.FINANCE],
  '/z-reports': [PERMISSION_SCOPE.FINANCE],
  '/z-reports/debug': [PERMISSION_SCOPE.FINANCE],
  '/pos-item-report': [PERMISSION_SCOPE.FINANCE],
  '/fortnox-report': [PERMISSION_SCOPE.FINANCE],
  '/orders-report': [PERMISSION_SCOPE.FINANCE],

  /* INTEGRATIONS gives permission to: */
  '/integrations/configs/:id?': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/send-vouchers': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/vouchers': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/invoices': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/configs/old/:id?': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/gstock': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/gstock/:id': [PERMISSION_SCOPE.INTEGRATIONS],
  '/integrations/personalkollen': [PERMISSION_SCOPE.INTEGRATIONS],

  /* LOANS gives permission to: */

  /* ORDERS gives permission to: */
  '/orders': [PERMISSION_SCOPE.ORDERS],

  /* MENUS gives permission to: */
  '/menus-select': [PERMISSION_SCOPE.MENUS],
  '/menus': [PERMISSION_SCOPE.MENUS],
  '/menus/create': [PERMISSION_SCOPE.MENUS],
  '/menus/edit/:id': [PERMISSION_SCOPE.MENUS],

  '/pim/menus': [PERMISSION_SCOPE.POS_CUSTOMIZATION, PERMISSION_SCOPE.MENUS],
  '/pim/menus/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION, PERMISSION_SCOPE.MENUS],

  /* POS_CUSTOMIZATION gives permission to: */
  '/app/memberships': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/memberships/update': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/memberships/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/memberships/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/assign-points': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/users': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/users': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/users/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/users/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/users/analytics/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/send-csv': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/send-excel': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/shopping-carts': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/members': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/app/members/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/offers': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/offers/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/offers/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stampcards': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stampcards/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stampcards/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/campaigns': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/campaigns/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/campaigns/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/campaigns/wizard': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/signupcodes': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/signupcodes/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/signupcodes/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/promocodes': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/promocodes/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/notifications': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/segments': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/segments/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/insights': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/gift-cards-beta': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/gift-cards-beta/reports': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/gift-cards-beta/:shortcode': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/gift-cards/admin': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/legacy-payment-methods/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/legacy-payment-methods/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/legacy-payment-methods': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/payment-methods': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/payment-methods/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/cash': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/deliveries': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/deliveries/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/deliveries/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/contents': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/contents/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/contents/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/tsr/zones': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/zones/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/zones/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/monitoring': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/tables': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/floorplans': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/floorplans/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/floorplans/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/messages': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/messages/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/tsr/messages/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/pos': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/layouts': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/layouts/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/layouts/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/posCategories': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/posCategories/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/posCategories/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/pages': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/pages/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/pages/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/kds/explorer': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/pim': [PERMISSION_SCOPE.POS_CUSTOMIZATION, PERMISSION_SCOPE.MENUS],
  '/pim/:path': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/pim/:path/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/categories': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/categories/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/categories/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stations': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stations/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/stations/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variations': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variations/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variations/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variationGroups': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variationGroups/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/variationGroups/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/items': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/items/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/items/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/upsells/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/upsells/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/upsells': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/messages': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/messages/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/messages/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/coursetypes': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/coursetypes/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/coursetypes/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/menu-editor': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/beepers': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/ingredients-beta': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/ingredients-beta/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/express-pages/create': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/express-pages/edit/:id': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/express-pages': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/inventory': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  '/online': [PERMISSION_SCOPE.POS_CUSTOMIZATION],
  '/online-ordering': [PERMISSION_SCOPE.POS_CUSTOMIZATION],

  /* SETTINGS gives permission to: */
  '/legacy-venues': [PERMISSION_SCOPE.SETTINGS],
  '/legacy-venues/create': [PERMISSION_SCOPE.SETTINGS],
  '/legacy-venues/edit/:id': [PERMISSION_SCOPE.SETTINGS],
  '/venues': [PERMISSION_SCOPE.SETTINGS],
  '/venues/:id': [PERMISSION_SCOPE.SETTINGS],
  '/receiptTemplates': [PERMISSION_SCOPE.SETTINGS],
  '/receiptTemplates/edit/:id': [PERMISSION_SCOPE.SETTINGS],
  '/receiptTemplates/create': [PERMISSION_SCOPE.SETTINGS],
  '/opening-hours': [PERMISSION_SCOPE.SETTINGS],
  '/opening-hours/edit/:id': [PERMISSION_SCOPE.SETTINGS],

  /* STAFF gives permission to: */
  '/access-levels': [PERMISSION_SCOPE.STAFF],
  '/access-levels/edit/:id': [PERMISSION_SCOPE.STAFF],
  '/access-levels/create': [PERMISSION_SCOPE.STAFF],
  '/staffs': [PERMISSION_SCOPE.STAFF],
  '/staffs/edit/:id': [PERMISSION_SCOPE.STAFF],
  '/staffs/create': [PERMISSION_SCOPE.STAFF],

  '/staff-report': [PERMISSION_SCOPE.STAFF, PERMISSION_SCOPE.FINANCE],
};
